export class SafeStorage {
  static get(key: string): string | null {
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  }

  static set(key: string, value: string): void {
    try {
      window.localStorage.setItem(key, value);
    } catch {
      return;
    }
  }

  static remove(key: string): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      return;
    }
  }
}
